class FancySlider extends HTMLElement {
  constructor() {
    super(); // Always call super first in the constructor

    // Initialize properties
    this.thumbsSwiper = null;
    this.mainSwiper = null;
  }

  connectedCallback() {
    this.initSwipers();
    this.updateCopyVisibility(); // Initial update for visibility
  }

  initSwipers() {
    // Assuming Swiper is already included in your project
    this.thumbsSwiper = new Swiper(this.querySelector(".thumbs-swiper"), {
      spaceBetween: 10,
      slidesPerView: 2,
      loop: true,
    });

    this.mainSwiper = new Swiper(this.querySelector(".main-swiper"), {
      autoplay: {
        delay: 3000,
      },
      spaceBetween: 10,
      slidesPerView: 1.1,
      loop: true,
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      pagination: {
        el: this.querySelector('.pagination'),
        type: 'fraction',
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.button-next'),
        prevEl: this.querySelector('.button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
    });

    this.mainSwiper.on("slideChange", () => this.updateCopyVisibility());
  }

  updateCopyVisibility() {
    const slides = this.querySelectorAll('.fs-slider__copy');
    const activeSlide = this.querySelector(`.fs-slider__copy[data-slide="${this.mainSwiper.realIndex}"]`);

    slides.forEach(slide => slide.classList.remove('fs-slider__copy--active'));
    if (activeSlide) {
      activeSlide.classList.add('fs-slider__copy--active');
    }
  }
}

// Define the new element
customElements.define('fancy-slider', FancySlider);